module.exports = __webpack_public_path__ + "img/add-photo.fa69a7a4.svg";